import { Link } from "react-router-dom";
import { Header, NavBar, VideoCard } from "../../components";
import { useLikeWatchLater } from "../../context";
import { useDocumentTitle } from "../../customHooks";
import "../commonPage.css";

export const LikePage = () => {
  useDocumentTitle("LikePage");
  const { likedList } = useLikeWatchLater();

  return (
    <main className="page-main">
      <Header />
      <NavBar />
      <section className="page-content padding-xs">
        {likedList.length === 0 ? (
          <div className=" padding-sm no-like-video">
            <h1 className="head-lg text-center text-gray">
              No video is here
              <Link to="/" className="navigate-link">
                Click here
              </Link>
              to check some videos
            </h1>
          </div>
        ) : (
          <div className="like-video-container">
            {likedList.map((item) => (
              <VideoCard
                key={item?.video?._id}
                video={item?.video}
                isLike={true}
              />
            ))}
          </div>
        )}
      </section>
    </main>
  );
};
